<div>
    <p><strong>First Name: </strong> {{profile.givenName}}</p>
    <p><strong>Last Name: </strong> {{profile.surname}}</p>
    <p><strong>Email: </strong> {{profile.userPrincipalName}}</p>
    <p><strong>Id: </strong> {{profile.id}}</p>
</div>
